import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';

/* script */

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"1em","height":"1em","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M7.99333 1.33325C4.31333 1.33325 1.33333 4.31992 1.33333 7.99992C1.33333 11.6799 4.31333 14.6666 7.99333 14.6666C11.68 14.6666 14.6667 11.6799 14.6667 7.99992C14.6667 4.31992 11.68 1.33325 7.99333 1.33325ZM12.6133 5.33325H10.6467C10.4333 4.49992 10.1267 3.69992 9.72666 2.95992C10.9533 3.37992 11.9733 4.23325 12.6133 5.33325ZM7.99999 2.69325C8.55333 3.49325 8.98666 4.37992 9.27333 5.33325H6.72666C7.01333 4.37992 7.44666 3.49325 7.99999 2.69325ZM2.84 9.33325C2.73333 8.90658 2.66666 8.45992 2.66666 7.99992C2.66666 7.53992 2.73333 7.09325 2.84 6.66658H5.09333C5.03999 7.10659 4.99999 7.54659 4.99999 7.99992C4.99999 8.45325 5.03999 8.89325 5.09333 9.33325H2.84ZM3.38666 10.6666H5.35333C5.56666 11.4999 5.87333 12.2999 6.27333 13.0399C5.04666 12.6199 4.02666 11.7733 3.38666 10.6666ZM5.35333 5.33325H3.38666C4.02666 4.22659 5.04666 3.37992 6.27333 2.95992C5.87333 3.69992 5.56666 4.49992 5.35333 5.33325ZM7.99999 13.3066C7.44666 12.5066 7.01333 11.6199 6.72666 10.6666H9.27333C8.98666 11.6199 8.55333 12.5066 7.99999 13.3066ZM9.55999 9.33325H6.43999C6.37999 8.89325 6.33333 8.45325 6.33333 7.99992C6.33333 7.54659 6.37999 7.09992 6.43999 6.66658H9.55999C9.61999 7.09992 9.66666 7.54659 9.66666 7.99992C9.66666 8.45325 9.61999 8.89325 9.55999 9.33325ZM9.72666 13.0399C10.1267 12.2999 10.4333 11.4999 10.6467 10.6666H12.6133C11.9733 11.7666 10.9533 12.6199 9.72666 13.0399ZM10.9067 9.33325C10.96 8.89325 11 8.45325 11 7.99992C11 7.54659 10.96 7.10659 10.9067 6.66658H13.16C13.2667 7.09325 13.3333 7.53992 13.3333 7.99992C13.3333 8.45992 13.2667 8.90658 13.16 9.33325H10.9067Z","fill":"currentColor"}})])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    {},
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
